import { RootState } from "../store/store"

export function selectKitchen({ nonAdminUser }: RootState) {
    return nonAdminUser.selectedKitchen
}
